import React from 'react'
import '../pages/css/Home.css';
import healthcare1 from '../images/healthcare1.jpg';
import healthcare2 from '../images/healthcare2.jpg';
import healthcare3 from '../images/healthcare3.jpg';
import banner from '../images/healthcare-banner.jpg';

function Healthcare() {
    return (
        <>   <section
            id="contact-section-page"
            style={{
                backgroundImage: `url(${banner})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative', // Important for overlay
                zIndex: 1,
            }}
        >
            {/* Overlay */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)', // semi-transparent black
                    zIndex: 2,
                }}
            ></div>

            <section className="container-fluid px-3 px-md-5 pt-3 pb-5" style={{ position: 'relative', zIndex: 3 }}>
                <div className="row justify-content-center text-center">
                    <div className="col-lg-10">
                        <h1 className="fw-bold display-5 text-white" style={{ fontSize: '4.5rem' }}>Healthcare
                        </h1>
                        <p className="fs-2 fw-medium text-white mt-3">
                            We build HIPAA-compliant healthcare software that enhances patient care, streamlines operations, and enables secure data management across systems.
                        </p>
                    </div>
                </div>
            </section>
        </section>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">Our  <span className="highlight-orange">Healthcare</span> Services
                    </div>
                </div>
            </section>

            <section className="container my-5">
                {/* Healthcare Information Systems */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="Healthcare Information Systems"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Healthcare</span> IT Solutions
                        </h1>
                        <p className="mb-4">
                            <h2>Empowering healthcare providers with digital tools for efficient, patient-centered care delivery and seamless interoperability.</h2>
                        </p>

                        <h6 className="fw-bold mb-2 highlight-orange">Key Highlight:</h6>
                        <p className="mb-4 ps-3">
                            <h4>Our healthcare IT services cover EHR/EMR development, patient portals, telemedicine apps, and HIPAA-compliant systems tailored to hospitals, clinics, and startups.</h4>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Telemedicine & Remote Patient Monitoring */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Telemedicine</span> & RPM
                        </h1>

                        <p className="mb-4">
                            <h2>Connect patients and doctors remotely with secure, real-time video consultations and continuous health monitoring platforms.</h2>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Video Consultation Apps</h4>
                        <p className="mb-2 ps-3">
                            <h5>Build HIPAA-compliant video platforms enabling virtual doctor visits with e-prescription support.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Remote Monitoring Devices</h4>
                        <p className="mb-2 ps-3">
                            <h5>Integrate IoT-enabled wearables to track vitals like heart rate, glucose, oxygen saturation, and more in real time.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Patient Engagement Tools</h4>
                        <p className="mb-2 ps-3">
                            <h5>Improve outcomes with mobile apps that enable appointment reminders, medication tracking, and direct messaging.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">AI-Based Risk Prediction</h4>
                        <p className="mb-2 ps-3">
                            <h5>Use artificial intelligence to identify at-risk patients through data-driven predictive analysis.</h5>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="Telemedicine and Remote Patient Monitoring"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Hospital Management & Workflow Automation */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="Hospital Workflow and Automation"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Hospital</span> Workflow Automation
                        </h1>

                        <p className="mb-4">
                            <h2>Streamline hospital operations with customized software for scheduling, inventory, billing, and clinical workflows.</h2>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Smart Scheduling</h4>
                        <p className="mb-2 ps-3">
                            <h5>Automate doctor appointments, surgery calendars, and ward occupancy with real-time updates.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Digital Billing & Claims</h4>
                        <p className="mb-2 ps-3">
                            <h5>Manage insurance claims, co-payments, and automated billing with integrated payment gateways.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Pharmacy & Inventory Management</h4>
                        <p className="mb-2 ps-3">
                            <h5>Track medicine stocks, expiry dates, and supply chains with real-time dashboards and alerts.</h5>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>
            </section>

        </>

    )
}

export default Healthcare;